import type { Story } from '@/store/story-types'

export const FOOD_DELIVERY_APP_STORY: Story = {
  id: 'food-delivery-app',
  name: 'FoodDash — Food Delivery',
  narrative: 'A food delivery app where users browse nearby restaurants, order food, and track delivery in real time.',
  goals: ['Browse nearby restaurants', 'View restaurant menu and order', 'Manage cart and checkout', 'Track delivery status in real time'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'home',
      description: 'Landing page with header, hero banner, restaurant list, and footer',
      blockRef: { category: 'delivery', blockId: 'delivery-hero' },
    },
    {
      id: 'pg-restaurant-detail', title: 'Restaurant', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'restaurant-detail',
      description: 'Restaurant detail page with menu items and add-to-cart actions',
      blockRef: { category: 'delivery', blockId: 'restaurant-menu' },
    },
    {
      id: 'pg-cart', title: 'Your Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart page with ordered items, quantity controls, and checkout button',
      blockRef: { category: 'delivery', blockId: 'order-cart' },
    },
    {
      id: 'pg-tracking', title: 'Order Tracking', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'tracking',
      description: 'Real-time order tracking page with status timeline and delivery map',
      blockRef: { category: 'delivery', blockId: 'order-tracking' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Restaurants',
      description: 'User browses available restaurants on the home page',
      steps: [
        { type: 'given', text: 'the user is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner and list of nearby restaurants are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Restaurant Menu',
      description: 'User taps a restaurant to see its menu',
      steps: [
        { type: 'given', text: 'the user is on the home page' },
        { type: 'when', text: 'they tap a restaurant card' },
        { type: 'then', text: 'the restaurant menu with categories and item prices is displayed', linkedPageId: 'restaurant-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add Items and View Cart',
      description: 'User adds menu items and reviews the cart',
      steps: [
        { type: 'given', text: 'the user is viewing a restaurant menu', linkedPageId: 'restaurant-detail' },
        { type: 'when', text: 'they add items and navigate to the cart' },
        { type: 'then', text: 'the cart shows all selected items with quantities and total', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Place Order and Track Delivery',
      description: 'User places an order and tracks delivery status',
      steps: [
        { type: 'given', text: 'the user has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they confirm the order' },
        { type: 'then', text: 'the order tracking page shows delivery status and estimated time', linkedPageId: 'tracking' },
        { type: 'and', text: 'the status updates in real time as the order progresses', linkedFlowId: 'trackDelivery' },
      ],
    },
  ],
}
